module.exports = __webpack_public_path__ + "img/product2.ee335b13.jpg";